import {CLStore} from 'common/src/redux/store';
import initializeAnalyticsAgents from './initializeAnalyticsAgents';

function initializeAnalytics(store: CLStore) {
  initializeAnalyticsAgents(store);
}

export default initializeAnalytics;
